export async function setNodeData(nodes, transform) {
    for (const node of nodes) {
        const {data} = node
        node.data = transform(node)
        await this.onSetNodeData(node, data)
        this.logger.info('已设置节点数据', [node])
    }
}
